// Service layer entry point
// Always use real API service

import apiService from './api';

// Export the real API service
export const service = apiService;

// Re-export types and utilities
export { ApiError, handleApiError } from './api';
export type { HealthProfessional, CallRequestData, CallConfirmation } from '../types';

// Export individual services for direct access if needed
export const healthProfessionalService = service.healthProfessionals;
export const callRequestService = service.callRequests;
export const healthCheck = service.healthCheck;

export default service;